import React, { Component } from "react";
import CreateJoinHeader from "./../../myContest/createJoinContest/createJoinHeader";
import config from "./../../../common/config";
import app from "./../../../common/app";
import PrivacyPolicies from "../../overlayQuestion/HelpPricyPolicy";

class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  toggleMenu = (flag) => {
    let self = this;
    const { props } = self;
    const { isShowHideMenu } = props;
    isShowHideMenu && isShowHideMenu({ flag: flag });
  };

  componentDidMount() {
    this.toggleMenu(false);
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    this.toggleMenu(true);
  }

  onClickRedirect = (page) => {
    const { history = null } = this.props;
    if (history) {
      const sSearch = app.getUTMParameters();
      history.push(`${config.URL_BASE}${page}${sSearch}`);
    }
  };

  render() {
    let self = this;
    return (
      <div className="m11c-cmo__wrap">
        <div className="m11c-cmo__lhs">
          <div className="m11c-cmo__lhs-head">
            <CreateJoinHeader
              propsHeader={{ transKey: "privacy_policy" }}
              enableBack={true}
              enableHelp={false}
              eventBack={() => this.onClickRedirect(config.enumStaticUrls.more)}
            />
          </div>
          <div className="m11c-cmo__lhs-body" style={{ marginTop: "54px" }}>
            <PrivacyPolicies />
          </div>
        </div>
      </div>
    );
  }
}

export default PrivacyPolicy;
